import { useParameterStore } from '@/frontend/store/ParameterStore';
import { I18n } from '@/i18n/I18n';
import { ParameterType } from '@/types/parameterTypes';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useShallow } from 'zustand/react/shallow';
import { ParameterEditModalCard } from './ParameterEditModalCard';


export function ParameterRunEditModal(props: { subjectId: string, parameterType: ParameterType, buttonLabel: string, buttonClassName?: string }) {
  const { subjectId, parameterType, buttonLabel, buttonClassName } = props;
  const parameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(subjectId, parameterType)));

  const [show, setShow] = useState(false);

  return (
    <>
      <button type='button' className={`btn btn-primary btn-sm ${buttonClassName}`} onClick={() => setShow(true)}>{buttonLabel}</button>
      <Modal show={show} onHide={() => setShow(false)} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>{I18n.get('edit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex flex-column gap-3'>
            { parameters.map(parameter => {
              return <ParameterEditModalCard key={parameter.id} parameter={parameter} />;
            })}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
